const adminUsersListConstantsEn = {
  totalMembers: 'Members',
  deleteUserTitle: 'Delete User',
  deleteUserContent: 'Are you sure you want to delete this user from the admin panel ?',
  firstName: 'FIRST NAME',
  lastName: 'LAST NAME',
  email: 'EMAIL',
  role: 'ROLE',
  userStatus: 'STATUS',
  adminUsersTitle: 'Admin Users',
  activate: 'Activate',
  deactivate: 'Deactivate',
  inactive: 'Inactive',
  active: 'Active',
  admin: 'Admin',
  dataEntry: 'Data Entry',
  noRole: 'No Role',
};

export default adminUsersListConstantsEn;
